document.addEventListener("DOMContentLoaded", function() {
  const tabs = document.querySelectorAll(".tab-link");
  const items = document.querySelectorAll(".tab-item");

  tabs.forEach(tab => {
    tab.addEventListener("click", function() {
      const target = tab.dataset.tab;

      tabs.forEach(t => t.classList.remove("active"));
      items.forEach(item => item.classList.remove("active"));

      tab.classList.add("active");
      document.getElementById(target).classList.add("active");
    });
  });

  document.querySelectorAll(".tab-header").forEach(header => {
    header.addEventListener("click", function() {

      const currentItem = header.parentElement;
      const currentId = currentItem.id;

      items.forEach(item => {
        if (item !== currentItem) {
          item.classList.remove("active");
        }
      });

      currentItem.classList.toggle("active");
      tabs.forEach(tab => {
        tab.classList.remove("active");
        if (tab.dataset.tab === currentId && currentItem.classList.contains("active")) {
          tab.classList.add("active");
        }
      });

    });
  });

});
